import React, { useState, useEffect } from 'react';
import { Col, Row, Container, Table, Form, Button, Modal, Alert } from 'react-bootstrap';
import NavBar from '../Components/NavBar';
import SideNavbar from '../Components/SideNavbar';
import '../index.css'
import { useNavigate, useParams } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { connect } from 'react-redux'
import { getCampaignInfo } from '../Store/Actions/campaign'
import { setParticipantId } from '../Store/Actions/state'
import AlertBox from '../Components/AlertBox'
import axios from 'axios';
import { FaArrowLeft } from "react-icons/fa";
import Loader from '../Components/Loader'
import { Auth } from 'aws-amplify';
import { DataGrid } from '@mui/x-data-grid';
import { FaDownload, FaEdit, FaTrash } from 'react-icons/fa';
import getApiUrl from '../config';


function CampaignDashboard(props) {
    const [currentSideActive, setCurrentSideActive] = useState(0)
    const [selectValue, setSelectValue] = useState("totalPar");
    const [order, setOrder] = useState("normal")
    const { managerid } = useParams();
    const [participantList, setParticipantList] = useState([])
    const [campaignName, setCampaignName] = useState("")
    const [campaignId, setCampaignId] = useState("")
    const [avgCompliance, setAvgComplinace] = useState(0)
    const [avgWearingTime, setAvgWearingTime] = useState(0)
    const [alertShow, setAlertShow] = useState([false, ""])
    const [errorMsg, setErrorMsg] = useState("");
    const [loader, setLoader] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedDataTypes, setSelectedDataTypes] = useState([]);
    const [currentParticipant, setCurrentParticipant] = useState(null);
    const [collectionTime, setCollectionTime] = useState("-")
    const [role, setRole] = useState("");


    const [isAllSelected, setIsAllSelected] = useState(false);
    const [showModalForDataTypes, setShowModalForDataTypes] = useState(false);
    const [popupMessage, setPopupMessage] = useState(null);



    const navigate = useNavigate()

    useEffect(() => {
        //handleInfo()
        Auth.currentSession().then(session => {
            if (session.isValid()) {
                const userRole = session.getIdToken().payload["custom:role"];
                setRole(userRole);
                if (userRole == "manager" || userRole == "coordinator" || userRole == "admin") {
                    handleInfoDummy()
                }
                else {
                    if (userRole == "participant") {
                        navigate("/participantDashboard")
                    }
                }
            }
            else {
                Auth.signOut()
                navigate("/")
            }
        }).catch(error => {
            Auth.signOut()
            navigate("/")
        })
    }, []);

    useEffect(() => {
        setCampaignName(props.campaign.campaignName);
        setCampaignId(props.campaign.campaignId);
        setParticipantList(props.campaign.participantList);
    }, [props.campaign]);

    const handleInfo = async (managerId, campaignId) => {
        await props.getCampaignInfo(props.state.managerId, props.state.campaignId)
    }

    const handleInfoDummy = async () => {
        setLoader(true)
        try {
            //axios call
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };

            const requestData = {
                campaign_id: localStorage.getItem("campaignId"),
                managerid: localStorage.getItem("managerId")
            }
            const response = await axios.post(getApiUrl('newCampaignDashboard'), requestData, config)
            console.log(response)
            if (response.status != 200) {
                setLoader(true)
                setAlertShow([true, "danger"])
                setErrorMsg(response.data.error)
            }
            //update the data format required for the dispatch
            else {
                setParticipantList(response.data)
                calaculateAvgCompliance(response.data)
                setCampaignId(localStorage.getItem("campaignId"))
                setCampaignName(localStorage.getItem("campaignId"))
                setLoader(false)
            }

            //dispatch the action

        }
        catch (err) {
            setLoader(true)
            setAlertShow([true, "danger"])
            setErrorMsg(err.message)
            console.log(err)
        }
    }


    const calaculateAvgCompliance = (participants) => {
        let totalCompliance = 0;
        participants.forEach((participant) => { totalCompliance += participant["compliance"] });
        totalCompliance = totalCompliance / participants.length;

        setAvgComplinace(totalCompliance);
    }

    useEffect(() => {
        try {
            const dateOnly = new Date(participantList[0]["timestamps"].replace(" ", "T"));

            // Format the date as YYYY-MM-DD
            const month = String(dateOnly.getMonth() + 1).padStart(2, "0");
            const day = String(dateOnly.getDate()).padStart(2, "0");
            const year = dateOnly.getFullYear();

            // Combine components into MM-DD-YYYY format
            const formattedDate = `${month}-${day}-${year}`;
            setCollectionTime(formattedDate)
        }
        catch (e) {
            console.log(e)
            setCollectionTime("-")
        }
    }, [avgCompliance])
    // Open modal for the selected participant
    const handleDownloadClick = (participant) => {
        setCurrentParticipant(participant);
        setShowModalForDataTypes(true); // Open modal for data types
    };

    // Close modal
    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedDataTypes([]);
    };

    //   Handle checkbox selection
    const handleCheckboxChangeDatatypes = (e) => {
        const { name, checked } = e.target;
        setSelectedDataTypes((prev) =>
            checked ? [...prev, name] : prev.filter((type) => type !== name)
        );
    };
    const handleCheckboxChange = (e, isAll) => {
        const { name, checked } = e.target;

        if (isAll) {
            // If "Select All" is checked/unchecked
            setIsAllSelected(checked);
            setSelectedDataTypes(checked ? [...new Set(participantList.map(p => p.participantid))] : []); // If "All" is selected, add all PIDs
        } else {
            // If an individual checkbox is selected, update state only if "All" is not selected
            if (!isAllSelected) {
                setSelectedDataTypes((prev) =>
                    checked ? [...prev, name] : prev.filter((type) => type !== name)
                );
            }
        }
    };


    // Download selected data
    const handleDownloadData = async () => {
        const { campaignid, participantid } = currentParticipant;
        console.log(currentParticipant);

        const requestPayload = {
            campaign_id: campaignid,
            email: localStorage.getItem("userEmail"),
            participant_id: participantid,
            selection: selectedDataTypes,
        }

        console.log(requestPayload);

        try {
            // Make a POST request to the Lambda API
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };
            const response = await axios.post(
                getApiUrl('newGetCsvFiles', {}),
                requestPayload,
                config
            );

            console.log(`response : ${response.data.body}`);
            if (response.status === 200) {
                handleCloseModal(); // Close the modal
                window.alert(`Data download has started. The data will be sent to ${localStorage.getItem("userEmail")}`);
            } else {
                alert('Failed to start the data download.');
            }


        } catch (error) {
            console.error('Error downloading file:', error);
            alert('An error occurred while downloading the file.');
        }

        handleCloseModal();
    };


    const handleDownloadAllData = async () => {
        setShowModal(true); // Open modal for selecting participant IDs
        setIsAllSelected(false); // Reset "Select All" checkbox
        setSelectedDataTypes([]); // Clear selected data types
    };
    const handleDownloadAllDataFromModal = async () => {
        console.log("Downloading all participant data...");

        const participantIdsToSend = isAllSelected
            ? participantList.map((p) => p.participantid) : selectedDataTypes;

        const requestPayload = {
            campaign_id: campaignId,
            participant_id_list: participantIdsToSend,
            email: localStorage.getItem("userEmail"),
        }

        console.log(requestPayload);

        try {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };
            // const response = await axios.post(
            //     getApiUrl('newGetBulkData',{}),
            //     requestPayload,
            //     { responseType: 'json' },config);
            const response = await axios.post(
                getApiUrl('newGetBulkData', {}),
                requestPayload,
                config
            );

            console.log(response);

            if (response.status === 200) {
                handleCloseModal(); // Close the modal
                window.alert(`Data download has started. The data will be sent to ${localStorage.getItem("userEmail")}`);
            } else {
                alert('Failed to start the data download.');
            }
        } catch (error) {
            console.error('Error downloading file:', error);
            alert('An error occurred while downloading the file.');
        }
    };


    const handleEditClick = (participant) => {
        // Placeholder: route to edit form or open modal
        console.log("Edit clicked:", participant);
        navigate("/editConfigureWatch");
    };

    const handleDeleteClick = async (participant) => {
        setPopupMessage({
            title: "Confirm Deletion",
            body: `⚠️ You are about to permanently delete participant "${participant.participantid}".\nThis action is irreversible. Do you want to continue?`,
            confirmAction: async () => {
                const requestPayload = {
                    manager_id: localStorage.getItem("managerId"),
                    campaign_id: campaignId,
                    participant_id: participant.participantid,
                    watchid: participant.watchid,
                    starttime: participant.startdate,
                };

                console.log("DELETE request payload:", requestPayload);
                const session = await Auth.currentSession();
                const token = session.getIdToken().getJwtToken();
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                };
                axios.post(
                    getApiUrl('newDeleteParticipant'),
                    requestPayload,
                    config
                ).then((response) => {
                    if (response.status === 200) {
                        setPopupMessage({
                            title: "Success",
                            body: "✅ Participant deleted successfully.",
                            confirmAction: () => setPopupMessage(null),
                            hideCancel: true
                        });
                        handleInfoDummy();
                    } else {
                        const errorBody = response.data;
                        setPopupMessage({
                            title: "Error",
                            body: response.data || "Failed to delete participant.",
                            confirmAction: () => setPopupMessage(null),
                            hideCancel: true
                        });
                    }
                }).catch((error) => {
                    console.error("Delete error:", error);
                    setPopupMessage({
                        title: "Error",
                        body: "An error occurred while deleting the participant.",
                        confirmAction: () => setPopupMessage(null),
                        hideCancel: true
                    });
                });
            }
        });
    };

    const renderPopup = () => {
        if (!popupMessage) return null;

        return (
            <Modal show onHide={() => setPopupMessage(null)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{popupMessage.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ whiteSpace: 'pre-wrap' }}>{popupMessage.body}</Modal.Body>
                <Modal.Footer>
                    {!popupMessage.hideCancel && (
                        <Button variant="secondary" onClick={() => setPopupMessage(null)}>Cancel</Button>
                    )}
                    <Button variant="primary" onClick={popupMessage.confirmAction}>OK</Button>
                </Modal.Footer>
            </Modal>
        );
    };


    return (
        <div style={{ height: "100%", overflowY: "auto" }} className="bg-image">
            <NavBar />
            <div style={{ height: "inherit" }}>
                <Container style={{ height: "100%" }}>
                    <Row style={{ height: "100%" }}>
                        <Col lg={2} style={{ height: "75%" }}>
                            {role == "admin" ? (<SideNavbar list={["Campaign Dashboard"]} active={currentSideActive} links={["/campaignDashboard"]} />) : (
                                <SideNavbar list={["Campaign Dashboard", "Create Participant", "Configure Watch"]} active={currentSideActive} links={["/campaignDashboard", "/createParticipant", "/configureWatch"]} />)}
                        </Col>
                        <Col style={{ height: "75%", overflow: "auto" }}>
                            {alertShow[0] ? (alertShow[1] == "danger" ? <AlertBox type="danger" message={errorMsg} /> : <></>) : <></>}
                            <Row>
                                <Col>
                                    <FaArrowLeft style={{ fontSize: "22px" }} onClick={() => { navigate("/managerDashboard") }} />
                                </Col>
                                <Col sm={6}>
                                    <Row>
                                        <h2 style={{ fontFamily: "GentonaLight" }}>Campaign Name: <b>{campaignName}</b></h2>
                                    </Row>
                                    {/* <Row>
                                <h4 style={{fontFamily:"GentonaLight"}}>Campaign Id: <b>{campaignId}</b></h4>
                            </Row> */}
                                </Col>

                                <Col style={{ display: "flex", justifyContent: "space-around" }} sm={5}>
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "cneter", alignItems: "center" }}>
                                        <h2><b>{avgCompliance.toFixed(2)}%</b></h2>
                                        <div>Avg. Compliance</div>
                                    </div>
                                    {/* <div style={{display:"flex",flexDirection:"column",justifyContent:"cneter",alignItems:"center"}}>
                            <h2><b>{avgWearingTime} hrs</b></h2>
                            <div>Avg. Wear Time</div>
                        </div> */}
                                </Col>
                                <Container style={{ padding: "15px" }}>
                                    <Alert key={'primary'} variant={"primary"}>The Data in the columns {<b>Prompt Count, Compliance, Sensor Count, Battery Decay</b>} are calculated only for the data collected on {<b>{collectionTime ? collectionTime : "-"}</b>}</Alert>
                                </Container>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Button variant="primary" onClick={handleDownloadAllData}>
                                        Download All Data
                                    </Button>
                                </Col>
                            </Row>
                            <Row className="mt-3">

                                <BootstrapTable keyField='name' data={participantList} columns={[
                                    {
                                        dataField: 'participantid',
                                        text: 'PID',
                                        sort: true,
                                        style: {
                                            wordBreak: 'break-word', // Allows long PIDs to wrap within cell
                                            whiteSpace: 'normal',    // Allows wrapping
                                        }
                                    },
                                    {
                                        dataField: 'startdate',
                                        text: 'Start Date',
                                        sort: true
                                    },
                                    {
                                        dataField: 'endtime',
                                        text: 'End Date',
                                        sort: true
                                    },
                                    {
                                        dataField: 'watchid',
                                        text: 'WatchID',
                                    },
                                    {
                                        dataField: 'prompt_count',
                                        text: 'Prompt Count',
                                        sort: true
                                    },
                                    {
                                        dataField: 'compliance',
                                        text: 'Compliance (% per day)',
                                        sort: true
                                    },
                                    {
                                        dataField: 'sensor_count',
                                        text: 'Sensor Count',
                                        sort: true
                                    },
                                    {
                                        dataField: 'battery_decay',
                                        text: 'Battery Decay (% per hour)',
                                        sort: true
                                    },
                                    {
                                        dataField: "lastdata",
                                        text: "Date of last data (battery) capture",
                                        sort: true
                                    },
                                    {
                                        dataField: 'actions',
                                        text: 'Actions',
                                        formatter: (cell, row) => (
                                            <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', fontSize: '16px' }}>
                                                <FaEdit
                                                    style={{ cursor: 'pointer', color: '#0d6efd' }}
                                                    title="Edit"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleEditClick(row);
                                                    }}
                                                />
                                                <FaDownload
                                                    style={{ cursor: 'pointer', color: '#198754' }}
                                                    title="Download"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDownloadClick(row);
                                                    }}
                                                />
                                                <FaTrash
                                                    style={{ cursor: 'pointer', color: '#dc3545' }}
                                                    title="Delete"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDeleteClick(row);
                                                    }}
                                                />
                                            </div>
                                        ),
                                        headerAlign: 'center',
                                        align: 'center',
                                    }
                                ]}
                                    hover
                                    headerClasses={"table-header-style"}
                                    rowClasses={(row) => {
                                        const today = new Date().setHours(0, 0, 0, 0);
                                        const endDate = new Date(row.endtime).setHours(0, 0, 0, 0);
                                        const baseClass = "table-row-style";

                                        if (!row.endtime || isNaN(endDate)) return baseClass;

                                        return endDate < today ? `${baseClass} row-expired` : baseClass;
                                    }}
                                    rowEvents={{
                                        onClick: (e, row, rowIndex) => {
                                            localStorage.setItem("participantId", row.participantid);
                                            localStorage.setItem("startdate", row.startdate);
                                            localStorage.setItem("enddate", row.endtime);
                                            localStorage.setItem("battery_decay", row.battery_decay);
                                            localStorage.setItem("watchID", row.watchid);
                                            navigate("/participantDashboard");
                                        }
                                    }}
                                />
                                {/* Popup Modal for bulk download*/}

                                <Modal show={showModal} onHide={handleCloseModal} fullscreen={'lg-down'}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Select Participants to Download</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Form>
                                            {/* "Select All" Checkbox */}
                                            <Form.Check
                                                type="checkbox"
                                                name="All"
                                                label="Select All"
                                                onChange={(e) => handleCheckboxChange(e, true)} // Pass true for the "Select All" checkbox
                                                checked={isAllSelected}
                                            />

                                            {/* Individual Participant Checkboxes */}
                                            {[...new Set(participantList.map(p => p.participantid))].sort((a, b) => a.localeCompare(b)) // Sort PIDs alphabetically
                                                .map((pid) => (
                                                    <Form.Check
                                                        key={pid}
                                                        type="checkbox"
                                                        name={pid}
                                                        label={`PID: ${pid}`}
                                                        onChange={(e) => handleCheckboxChange(e, false)} // Pass false for individual checkboxes
                                                        checked={selectedDataTypes.includes(pid)}
                                                        disabled={isAllSelected} // Disable if "Select All" is selected
                                                    />
                                                ))}
                                        </Form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
                                        <Button variant="primary" onClick={handleDownloadAllDataFromModal}>Download</Button>
                                    </Modal.Footer>
                                </Modal>


                                {/* Popup Modal for individual download*/}
                                <Modal show={showModalForDataTypes} onHide={() => setShowModalForDataTypes(false)} fullscreen={'lg-down'}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Select Data to Download</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Form>
                                            {['Numeric', 'Discrete', 'Cognitive', 'GPS', 'HealthKit', 'All'].map((type) => (
                                                <Form.Check
                                                    key={type}
                                                    type="checkbox"
                                                    name={type}
                                                    label={type}
                                                    onChange={handleCheckboxChangeDatatypes}
                                                />
                                            ))}
                                        </Form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowModalForDataTypes(false)}>Close</Button>
                                        <Button variant="primary" onClick={handleDownloadData}>Download</Button>
                                    </Modal.Footer>
                                </Modal>




                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
            {renderPopup()}
        </div>
    );
}


const mapStateToProps = (state) => {
    return {
        user: state.user,
        manager: state.manager,
        campaign: state.campaign,
        state: state.state
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getCampaignInfo: (managerId, campaignId) => dispatch(getCampaignInfo(managerId, campaignId)),
        setParticipantId: (participantId) => dispatch(setParticipantId(participantId))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(CampaignDashboard);